export const getSportItemSet = (sportEventState='running') => JSON.stringify({
  query: `query SportItemSets {
  sportItemSets(filters: { sportEventState: ${sportEventState} }, first: 1) {
      sportItemSets {
          liveStatsUrl
          title
          subtitle
          sportEvent {
              startDate
              endDate
              state
          }
      }
  }
}
`
});
